import React from 'react'
import Header from './components/header/header'
import Sidebar from './components/sidebar/sidebar'
import { getBEMCls } from '@/utils/classname'
import Content from './modules/router'

import './main.scss'
import { RouteComponentProps } from 'react-router'

const Main = (props: RouteComponentProps) => {
    const getCls = (el?: string, moder?: string) => getBEMCls('sg-main', el, moder)

    return (
        <div className={getCls()}>
            <Header />
            <div className={getCls('content')}>
                <Sidebar />
                <main className={getCls('main')}>
                    <Content {...props} />
                </main>
            </div>
        </div>
    )
}

export default Main
